import { GET_FOOTER_PORTAL } from 'volto-ministerio-publico-federal/constants';

export function getFooterPortal() {
  return {
    type: GET_FOOTER_PORTAL,
    request: {
      op: 'get',
      path: `/@portal-footer-info`,
    },
  };
}
